import Checkbox from "@mui/material/Checkbox";

const LivisCheckBox = ({
  size = 24,
  disabled = false,
  checked = false,
  livis_on_change_function = () => {
    void 0;
  },
  className = "", // Default to empty string
  name,
  ...props // Capture any other standard MUI props
}: any) => {

  const combinedClassName = `livis-checkbox-component ${className}`.trim();

  return (
    <Checkbox
      {...props}
      disabled={disabled}
      checked={checked}
      className={combinedClassName}
      onChange={livis_on_change_function}
      inputProps={{ "aria-label": "controlled" }}
      name={name}
      sx={{
        "& .MuiSvgIcon-root": { fontSize: size },
      }}
    />
  );
};

export default LivisCheckBox;